module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-wrap",
    class: [_vm.$route.name + '-wrap']
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('router-view')], 1), _vm._t("footer", [_c('c-footer')])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a6847ea0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6847ea0","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@zbj/vue-mixin-loader?{"mixinPath":"D://zhubajie//Project//nodejs-zbjfins-web//app//resource//global//css//mixin//mixin.less"}!./app/resource/app.vue
// module id = 1205
// module chunks = 2